import { render } from "./ActualiteView.vue?vue&type=template&id=14d41440"
import script from "./ActualiteView.vue?vue&type=script&lang=js"
export * from "./ActualiteView.vue?vue&type=script&lang=js"

import "./ActualiteView.vue?vue&type=style&index=0&id=14d41440&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__